import React from 'react';
import clsx from 'clsx';
import styles from './index.module.css';

const VARIANT_STYLES = {
    primary: {
        dark: styles.primaryDark,
        light: styles.primaryLight,
    },
    accent: styles.accent,
};

const RouteButton = ({
    children,
    href,
    variant = 'primary',
    tone = 'dark',
    icon,
    className,
    onClick,
    ...props
}) => {
    const handleClick = (event) => {
        onClick?.(event);
        if (!event.defaultPrevented && href) {
            window.open(href, '_blank', 'noopener,noreferrer');
        }
    };

    const variantClass =
        variant === 'accent'
            ? VARIANT_STYLES.accent
            : VARIANT_STYLES.primary[tone] ?? VARIANT_STYLES.primary.dark;

    return (
        <button
            type="button"
            onClick={handleClick}
            className={clsx(styles.btn, variantClass, className)}
            {...props}
        >
            {icon}
            {children}
        </button>
    );
};

export default RouteButton;
